import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCustomerAuth, getStoredAuth } from '../contexts/CustomerAuthContext';
import { usePwaNav } from '../contexts/PwaNavContext';
import CustomerUserMenu from '../components/CustomerUserMenu';
import FriendsView from '../components/passport/FriendsView';
import { useFriendsData } from '../hooks/useFriendsData';
import '../components/FoodPassportPanel.css';

export default function FriendsPage() {
  const { t } = useTranslation();
  const { navigate } = usePwaNav();
  const { customer, token } = useCustomerAuth();
  const [localAuth] = useState(() => {
    if (customer && token) return null;
    return getStoredAuth();
  });

  const effectiveCustomer = customer ?? localAuth?.customer ?? null;
  const effectiveToken = token ?? localAuth?.token ?? null;

  const friends = useFriendsData({ effectiveToken, alwaysFetch: true });

  return (
    <div className="pp-container">
      <div className="pp-ambient" />

      <div className="pp-header">
        <button
          type="button"
          className="pp-back-btn"
          onClick={() => navigate('/')}
          aria-label={t('common.back', { defaultValue: 'Назад' })}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>
        </button>
        {effectiveCustomer && <CustomerUserMenu />}
      </div>

      {effectiveCustomer ? (
        <FriendsView
          friendsData={friends.friendsData}
          friendsLoading={friends.friendsLoading}
          inviteCopied={friends.inviteCopied}
          effectiveToken={effectiveToken}
          onCopyInvite={friends.handleCopyInvite}
          onAcceptFriend={friends.handleAcceptFriend}
          onDeclineFriend={friends.handleDeclineFriend}
          onUnfriend={friends.handleUnfriend}
          fetchFriends={friends.fetchFriends}
        />
      ) : (
        <div className="pp-guest" style={{ textAlign: 'center', padding: 32 }}>
          {t('foodPassport.signInToContinue', { defaultValue: 'Войдите чтобы пригласить друзей' })}
        </div>
      )}
    </div>
  );
}
